import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  style: {"enable-background":"new 0 0 16 16"},
  "xml:space": "preserve",
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "currentColor",
  class: "qi-1018"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("circle", {
  cx: "7.86",
  cy: "9.64",
  r: "2.807"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", { d: "M7.86 5.676c.973 0 1.636.475 1.833.628.013-.169.026-.382.027-.628.015-2.353-.956-5.15-1.856-5.15-.678 0-1.849 2.306-1.849 5.15 0 .211.016.412.027.617a3.018 3.018 0 0 1 1.818-.617zm-3.332 6.1a3.022 3.022 0 0 1-.372-1.901 8.765 8.765 0 0 0-.558.29C1.553 11.328-.384 13.567.066 14.347c.339.587 2.921.449 5.384-.973.183-.106.349-.22.52-.332a3.016 3.016 0 0 1-1.442-1.266zm7.871-1.762a9.013 9.013 0 0 0-.547-.285 3.021 3.021 0 0 1-.375 1.883 3.013 3.013 0 0 1-1.46 1.273c.175.114.344.23.53.338 2.463 1.422 5.046 1.559 5.388.967.45-.779-1.492-3.015-3.536-4.176z" }, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_4))
}
export default { render: render }